module.exports = __webpack_public_path__ + "static/media/Mamdoh Alzhrani.54199c9e.jpg";